import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import { LocationManager, SideDrawerModal, TouchableHighlight, TWCText } from '@components';

import { locationsIDs, settingsMenuTestIDs, settingsPageTestIDs } from '@constants';
import { useAppContextReference, useContextNodeHandle, useContextReference, useGetUserWatchingLocation } from '@hooks';

import { styles } from './styles';

import { TWCButton } from '../../focusable/TWCButton/TWCButton';

type SettingsLocationsProps = {
  additionalData: {
    enableLocationPanel?: boolean;
  };
};

export const SettingsLocations: FC<SettingsLocationsProps> = ({ additionalData }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'settingsPage.locations',
  });
  const [isLocationModalVisible, setLocationModalVisible] = useState(additionalData.enableLocationPanel ? true : false);
  const watchingLocation = useGetUserWatchingLocation();
  const settingsChangeLocationButtonReference = useContextReference<TouchableHighlight>(
    settingsPageTestIDs.locations.settingsChangeLocationButton,
  );
  const locationsMenuHandle = useContextNodeHandle(settingsMenuTestIDs.locations);

  const isPageFocused = useIsFocused();

  const lastRoute = useAppContextReference('lastRoute');

  useEffect(() => {
    if (isLocationModalVisible) {
      lastRoute.current = locationsIDs.changeLocationModal;
    } else if (isPageFocused) {
      lastRoute.current = 'MainMenu';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocationModalVisible, isPageFocused]);

  return (
    <View style={styles.settingsLocationsWrapper}>
      <View style={styles.settingsLocationsCurrentWrapper}>
        <TWCText testID={settingsPageTestIDs.locations.settingsLocationsWatchingText} variant={'regularText36'}>{`${t(
          'currentlyWatchingText',
        )}: `}</TWCText>
        <TWCText noTestID variant={'regularText36'}>
          {watchingLocation?.name}
        </TWCText>
      </View>
      <TWCButton
        accessibilityHint={t('currentlyWatchingAccessibiliyHint')}
        accessibilityLabel={t('currentlyWatchingAccessibiliyLabel', {
          location: watchingLocation?.name,
        })}
        nativeID={settingsPageTestIDs.locations.settingsChangeLocationButton}
        nextFocusDown={null}
        nextFocusLeft={locationsMenuHandle}
        nextFocusRight={null}
        nextFocusUp={null}
        ref={settingsChangeLocationButtonReference}
        testID={settingsPageTestIDs.locations.settingsChangeLocationButton}
        title={t('changeLocationButtonLabel')}
        onPress={() => setLocationModalVisible(true)}
      />
      <SideDrawerModal
        handleClose={() => {
          setLocationModalVisible(false);
        }}
        visible={isLocationModalVisible}
      >
        <LocationManager />
      </SideDrawerModal>
    </View>
  );
};
